// CustomFieldManager.jsx
import { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import {
  BsPerson,
  BsBriefcase,
  BsBuildings,
  BsBox,
  BsCheck2Square,
  BsArrowLeft,
} from "react-icons/bs"

import DealFields from "../DealFields"
import ContactFields from "../ContactFields"
import CompanyFields from "../CompanyFields"
import { Button } from "react-bootstrap"
import QuotationField from "./../QuotationField"
import SellsOrderField from "./../SellsOrderField"

const tabs = [
  { key: "deal", label: "Lead/Deal", icon: <BsBriefcase /> },
  { key: "contact", label: "Contact", icon: <BsPerson /> },
  { key: "company", label: "Company", icon: <BsBuildings /> },
  { key: "quotation", label: "Quotation", icon: <BsBox /> },
  { key: "sales", label: "Sales Order", icon: <BsCheck2Square /> },
]

const componentMap = {
  deal: <DealFields />,
  contact: <ContactFields />,
  company: <CompanyFields />,
  quotation: <QuotationField />,
  sales: <SellsOrderField />,
}

const CustomFieldManager = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  const defaultTab = "deal"
  const initialTab = searchParams.get("type") || defaultTab

  const isValidTab = (key) => tabs.some((tab) => tab.key === key)
  const [selectedTab, setSelectedTab] = useState(
    isValidTab(initialTab) ? initialTab : defaultTab
  )

  // Sync selected tab with URL on tab change
  const handleTabChange = (tabKey) => {
    setSelectedTab(tabKey)
    const params = new URLSearchParams(location.search)
    params.set("type", tabKey)
    const newUrl = `${location.pathname}?${params.toString()}`
    navigate(newUrl)
  }

  // Smart Back Button: go back if from /settings/preference, else redirect
  const handleBack = () => {
    if (document.referrer.includes("/settings/preference")) {
      navigate(-1)
    } else {
      navigate("/settings/preference")
    }
  }

  return (
    <div className="p-4 position-relative">
      <div className="d-flex justify-content-between align-items-center">

        <div className="d-flex gap-2 mt-1 mb-1 pb-0 align-items-center ">
          <div style={{ paddingRight: "20px" }}>
            <h5 className="fw-semibold mb-1">Forms</h5>
            <p className="text-muted small ">
              Create and manage custom fields to capture additional information across different modules. These fields will appear in the respective add and edit forms.
            </p>
          </div>
        </div>
        <div>
          <Button
            className="btn btn-default-outline ml-100%"
            onClick={handleBack}
            style={{ width: "max-content" }}
          >
            <BsArrowLeft className="me-1" /> Back
          </Button>
        </div>
      </div>
      <hr />
      <div style={{ backgroundColor: "white" }} className="container-table p-3 ">
        {" "}
        <div className="d-flex justify-content-between align-items-center">
          {/* Tabs */}
          <div className="d-flex gap-2 mt-1 mb-1 border-bottom pb-3 align-items-center ">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                aria-selected={selectedTab === tab.key}
                className={`d-flex align-items-center gap-1 fe-400 fs-14 text-decoration-none rounded px-3 py-2 ${selectedTab === tab.key
                  ? "fw-400 text-white bg-primary shadow-lg"
                  : "text-dark"
                  }`}
                style={{ border: "1px solid #dedddd" }}
                onClick={() => handleTabChange(tab.key)}
              >
                {tab.icon}
                {tab.label}
              </button>
            ))}
          </div>
          {/* <div style={{ marginRight: "25px" }}>
            <Button
              variant="btn btn-default-outline"
              onClick={handleBack}
              className="ml-100%"
            >
              <BsArrowLeft className="me-1" /> Back
            </Button>
          </div>

          Back Button */}
        </div>

        {/* Render selected tab component */}
        {componentMap[selectedTab] || null}
      </div>
    </div>
  );
};

export default CustomFieldManager
